
import React from "react";
import { Site } from "@/services/types";
import SitesMapSection from "./SitesMapSection";

interface SitesMapWrapperProps {
  sites: Site[];
  isLoading: boolean;
}

const SitesMapWrapper: React.FC<SitesMapWrapperProps> = ({ sites, isLoading }) => {
  return (
    <section className="mb-20" aria-labelledby="map-heading">
      <div className="text-center mb-10">
        <h2 id="map-heading" className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
          Localisez nos centres près de chez vous
        </h2>
        <div className="w-24 h-1 bg-fabre-teal mx-auto mb-6"></div>
        <p className="text-lg text-fabre-darkteal max-w-3xl mx-auto">
          Découvrez l'emplacement exact de tous nos centres de recyclage et d'achat de métaux. 
          Chaque site dispose d'équipements modernes et d'une équipe d'experts pour vous accompagner.
        </p>
      </div>
      <div className="bg-white rounded-3xl shadow-2xl border-2 border-fabre-green/20 overflow-hidden p-6">
        <SitesMapSection sites={sites} isLoading={isLoading} />
      </div>
    </section>
  );
};

export default SitesMapWrapper;
